import { createEntityReducer } from "@selas/state-management";

import Endpoint from "../../services/api/endpoint";
import { ISessionParticipant } from "../../utils/types/models";

export default createEntityReducer<ISessionParticipant>(Endpoint.SessionParticipants, Endpoint.SessionParticipantsList);
